export const svgShapes = {
    star: 'star',
    star8: 'star8',
    star4: 'star4',
    star6: 'star6',
    star4slim: 'star4slim',
    polygon6: 'polygon6',
    polygon6turned: 'polygon6turned',
    polygon5: 'polygon5',
    rectangle: 'rectangle',
    rhombus: 'rhombus',
    trianglePlay: 'trianglePlay',
    triangle: 'triangle',
    diamond: 'diamond',
    starTurned: 'starTurned',
    heart: 'heart',
    cross: 'cross',
    flag: 'flag',
    flagTriBottom: 'flagTriBottom',
    labelRight: 'labelRight',
    labelLeft: 'labelLeft',
    ribbon: 'ribbon',
    lightning: 'lightning',
    chatBubble1Left: 'chatBubble1Left',
    chatBubble1Right: 'chatBubble1Right',
    chatBubble2: 'chatBubble2',
    chatBubble3: 'chatBubble3',
    chatBubble4Left: 'chatBubble4Left',
    chatBubble4Right: 'chatBubble4Right',
}

export const svgShapesShapeList = [
    {
        value: svgShapes.rectangle,
        label: 'rectangle',
        padding: '14px'
    },
    {
        value: svgShapes.rhombus,
        label: 'rhombus',
        padding: '8px'
    },
    {
        value: svgShapes.triangle,
        label: 'triangle',
        padding: '12px 8px'
    },
    {
        value: svgShapes.trianglePlay,
        label: 'trianglePlay',
        padding: '12px'
    },
    {
        value: svgShapes.polygon5,
        label: 'polygon5',
        padding: '9px'
    },
    {
        value: svgShapes.polygon6,
        label: 'polygon6',
        padding: '6px 9px'
    },

    {
        value: svgShapes.star8,
        label: 'star8',
        padding: '5px'
    },

    {
        value: svgShapes.star6,
        label: 'star6',
        padding: '5px'
    },
    {
        value: svgShapes.star,
        label: 'star',
        padding: '6px'
    },
    {
        value: svgShapes.star4,
        label: 'star4',
        padding: '5px'
    },
    {
        value: svgShapes.star4slim,
        label: 'star4slim',
        padding: '5px'
    },
    {
        value: svgShapes.starTurned,
        label: 'starTurned',
        padding: '8px'
    },
    {
        value: svgShapes.diamond,
        label: 'diamond',
        padding: '10px 5px'
    },
    {
        value: svgShapes.lightning,
        label: 'lightning',
        padding: '6px 12px'
    },
    {
        value: svgShapes.heart,
        label: 'heart',
        borderRadiusProhibit: true,
        padding: '12px 8px'
    },
    {
        value: svgShapes.cross,
        label: 'cross',
        padding: '6px'
    },

]


export const svgShapesBoxList = [
    {
        value: svgShapes.rectangle,
        label: 'rectangle',
        padding: '14px'
    },
    {
        value: svgShapes.flag,
        label: 'flag',
        padding: '6px 12px'
    },
    {
        value: svgShapes.flagTriBottom,
        label: 'flagTriBottom',
        padding: '6px 12px'
    },
    {
        value: svgShapes.labelRight,
        label: 'labelRight',
        padding: '15px 6px'
    },
    {
        value: svgShapes.labelLeft,
        label: 'labelLeft',
        padding: '15px 6px'
    },
    {
        value: svgShapes.ribbon,
        label: 'ribbon',
        padding: '15px 6px'
    },
    {
        value: svgShapes.polygon6turned,
        label: 'polygon6turned',
        padding: '12px 6px'
    },
    {
        value: svgShapes.chatBubble1Left,
        label: 'chatBubble1Left',
        borderRadiusProhibit: true,
        padding: '6px'
    },
    {
        value: svgShapes.chatBubble1Right,
        label: 'chatBubble1Right',
        borderRadiusProhibit: true,
        padding: '6px'
    },
    {
        value: svgShapes.chatBubble2,
        label: 'chatBubble2',
        padding: '6px'
    },
    {
        value: svgShapes.chatBubble3,
        label: 'chatBubble3',
        borderRadiusProhibit: true,
        padding: '6px 10px'
    },
    {
        value: svgShapes.chatBubble4Left,
        label: 'chatBubble4Left',
        padding: '6px'
    },
    {
        value: svgShapes.chatBubble4Right,
        label: 'chatBubble4Right',
        padding: '6px'
    },
]

export const SvgStyle = (props = { uid: '125125', layers: [] }) => {
    return (
        <style type="text/css">
            {
                props.layers.map((value, index) => {
                    if (index > 0) {
                        return null
                    }

                    return (
                        `#svg-shape-${props.uid} path{fill:url(#svg-gradient-${props.uid}-${index})}`
                    )
                })
            }
        </style>
    )
}

const convertAngleToSvgGradient = () => {

}

export const GradientDef = (props = { gradientLayer: {}, index: 1, uid: '25124123' }) => {
    const angle = props.gradientLayer.angle
    let colors = props.gradientLayer.layerColors

    if (colors == undefined && props.gradientLayer.firstColor != undefined) {
        colors = [{ color: props.gradientLayer.firstColor, transition: 0 }, { color: props.gradientLayer.secondColor, transition: props.gradientLayer.transition }]
    }

    if (colors === undefined) {
        return null
    }

    // console.log('colors', colors)
    return (
        <defs>
            <linearGradient
                id={`svg-gradient-${props.uid}-${props.index}`}
                className={`svg-gradient`}
                gradientUnits='objectBoundingBox'
                gradientTransform={`rotate(${angle - 90}, .5, .5)`}
            >
                {
                    colors.map((value, index) => {
                        return (
                            <stop key={`stop-color-${props.uid}-${props.index}-${index}`} offset={`${value.transition}%`} stopColor={value.color}></stop>
                        )
                    })
                }
            </linearGradient>
        </defs>
    )
}

function createRoundedPathString(pathCoords = [{ x: 0, y: 0 }], borderRadius = 5) {
    const path = [];
    const curveRadius = borderRadius;

    // Reset indexes, so there are no gaps
    pathCoords = pathCoords.slice();

    for (let i = 0; i < pathCoords.length; i++) {

        // 1. Get current coord and the next two (startpoint, cornerpoint, endpoint) to calculate rounded curve
        const c2Index = ((i + 1) > pathCoords.length - 1) ? (i + 1) % pathCoords.length : i + 1;
        const c3Index = ((i + 2) > pathCoords.length - 1) ? (i + 2) % pathCoords.length : i + 2;

        const c1 = pathCoords[i];
        const c2 = pathCoords[c2Index];
        const c3 = pathCoords[c3Index];

        // console.log('c1', c1)
        // console.log('c2', c2)
        // console.log('c3', c3)

        // 2. For each 3 coords, enter two new path commands: Line to start of curve, bezier curve around corner.

        // Calculate curvePoint c1 -> c2
        const c1c2Distance = Math.sqrt(Math.pow(c1.x - c2.x, 2) + Math.pow(c1.y - c2.y, 2));
        const c1c2DistanceRatio = (c1c2Distance - curveRadius) / c1c2Distance;
        const c1c2CurvePoint = [
            ((1 - c1c2DistanceRatio) * c1.x + c1c2DistanceRatio * c2.x).toFixed(1),
            ((1 - c1c2DistanceRatio) * c1.y + c1c2DistanceRatio * c2.y).toFixed(1)
        ];

        // Calculate curvePoint c2 -> c3
        const c2c3Distance = Math.sqrt(Math.pow(c2.x - c3.x, 2) + Math.pow(c2.y - c3.y, 2));
        const c2c3DistanceRatio = curveRadius / c2c3Distance;
        const c2c3CurvePoint = [
            ((1 - c2c3DistanceRatio) * c2.x + c2c3DistanceRatio * c3.x).toFixed(1),
            ((1 - c2c3DistanceRatio) * c2.y + c2c3DistanceRatio * c3.y).toFixed(1)
        ];

        // If at last coord of polygon, also save that as starting point
        if (i === pathCoords.length - 1) {
            path.unshift('M' + c2c3CurvePoint.join(','));
        }

        // Line to start of curve (L endcoord)
        path.push('L' + c1c2CurvePoint.join(','));
        // Bezier line around curve (Q controlcoord endcoord)
        path.push('Q' + c2.x + ',' + c2.y + ',' + c2c3CurvePoint.join(','));
    }
    // Logically connect path to starting point again (shouldn't be necessary as path ends there anyway, but seems cleaner)
    path.push('Z');

    // console.log('path', path)

    return path.join(' ');
}


const pathToCoord = (path = '') => {
    let newPath = path.replaceAll('M', '')
    newPath = newPath.replaceAll('L', ';')
    newPath = newPath.replaceAll('H', ';')
    newPath = newPath.replaceAll('Z', '')

    let pathArray = newPath.split(';')

    let resultArray = []
    // for (let el of pathArray) {
    //     const [xPoint, yPoint] = el.split(' ')
    //     resultArray.push({ x: xPoint, y: yPoint })
    // }

    const commands = path.split(/(?=[LMC])/);
    for (let el of commands) {
        if (el.includes('M') || el.includes('L')) {
            let newEl = el.replaceAll('M', '')
            newEl = newEl.replace('L', '')
            const [xPoint, yPoint] = newEl.split(' ')
            resultArray.push({ x: parseFloat(xPoint), y: parseFloat(yPoint) })
        }
    }
    // console.log(resultArray)

    return resultArray
}

const getPathByType = (type = svgShapes.star) => {
    switch (type) {
        case svgShapes.star8:
            return 'M98 0L115.802 22.0058L141.388 9.90311L147.879 37.4535L176.183 37.651L170.078 65.2893L195.493 77.7479L178 100L195.493 122.252L170.078 134.711L176.183 162.349L147.879 162.547L141.388 190.097L115.802 177.994L98 200L80.1983 177.994L54.6116 190.097L48.1208 162.547L19.8168 162.349L25.9225 134.711L0.50721 122.252L18 100L0.50721 77.7479L25.9225 65.2893L19.8168 37.651L48.1208 37.4535L54.6116 9.90311L80.1983 22.0058Z'
        case svgShapes.star:
            return 'M100.895 0L128.706 66.8669L200.895 72.6542L145.895 119.768L162.698 190.211L100.895 152.462L39.0911 190.211L55.8945 119.768L0.894531 72.6542L73.083 66.8669Z'
        case svgShapes.polygon6:
            return 'M87 200L0.39745 150L0.397459 50L87 6.51651e-06L173.603 50L173.603 150Z'
        case svgShapes.polygon5:
            return 'M100.895 0L200.895 72.6542L162.698 190.211L39.0911 190.211L0.894531 72.6542Z'
        case svgShapes.star4:
            return 'M100 0L131.82 68.1802L200 100L131.82 131.82L100 200L68.1802 131.82L0 100L68.1802 68.1802Z'
        case svgShapes.star6:
            return 'M96 0L117.631 33.426L154.779 19.0983L152.631 58.855L191.106 69.0983L166 100L191.106 130.902L152.631 141.145L154.779 180.902L117.631 166.574L96 200L74.3688 166.574L37.2215 180.902L39.3688 141.145L0.894348 130.902L26 100L0.894348 69.0983L39.3688 58.855L37.2215 19.0983L74.3688 33.426Z'
        case svgShapes.star4slim:
            return 'M100 0L117.678 82.3223L200 100L117.678 117.678L100 200L82.3223 117.678L0 100L82.3223 82.3223Z'
        case svgShapes.diamond:
            return 'M160.656 0L39.3443 0L0 45.8498L100 144.099L200 45.8498Z'
        case svgShapes.starTurned:
            return 'M200 0L141.012 100L200 200L100 141.012L0 200L58.9878 100L0 0L100 58.9878Z'
        case svgShapes.flag:
            return 'M128.571 157.088L128.571 0L0 0L0 157.088L64.2857 200Z'
        case svgShapes.flagTriBottom:
            return 'M134 0L0 0L0 200L67 162L134 200Z'
        case svgShapes.labelRight:
            return 'M164 0L0 0L35 54L0 108L163.5 108L200 54Z'
        case svgShapes.labelLeft:
            return 'M36 0L200 0L165 54L200 108L36.5 108L0 54Z'
        case svgShapes.lightning:
            return 'M72 77.5L72 0L0 122.5L64.5 122.5L64.5 200L137 77.5Z'
        case svgShapes.rhombus:
            return 'M5 100L100 5L195 100L100 195Z'
        case svgShapes.ribbon:
            return 'M200 0L0 0L39 62L0 124L200 124L161 62Z'
        case svgShapes.trianglePlay:
            return 'M173.418 98.9915L2.23269 199.842L0.485886 1.16626Z'
        case svgShapes.triangle:
            return 'M100 0L200 174L0 174Z'
        case svgShapes.polygon6turned:
            return 'M40 124L0 62L40 0L160 0L200 62L160 124Z'
        case svgShapes.cross:
            return 'M145 0L55 0L55 55L0 55L0 145L55 145L55 200L145 200L145 145L200 145L200 55L145 55Z'
        case svgShapes.heart:
            return 'M14.475 84.3664C-4.825 65.0665 -4.82499 33.775 14.475 14.475C33.775 -4.82499 65.0665 -4.825 84.3664 14.475L100 30.1085L115.634 14.475C134.934 -4.825 166.225 -4.82499 185.525 14.475C204.825 33.775 204.825 65.0665 185.525 84.3664L129.612 140.28L129.394 140.061L100 169.555L70.6065 140.061Z'
        case svgShapes.chatBubble1Left:
            return 'M166.667 0H0V80.7475C0 99.1103 14.9238 113.996 33.3333 113.996H106.205L170.466 154V113.996H200V33.249C200 14.8861 185.076 0 166.667 0Z'
        case svgShapes.chatBubble1Right:
            return 'M33.3333 0H200V80.7475C200 99.1103 185.076 113.996 166.667 113.996H93.7953L29.534 154V113.996H-1.52588e-05V33.249C-1.52588e-05 14.8861 14.9238 0 33.3333 0Z'
        case svgShapes.chatBubble2:
            return 'M164 0L0 0L0 164L46 164L82 200L118 164L164 164Z'
        case svgShapes.chatBubble3:
            return 'M84.9059 0C38.0137 0 0 38.0137 0 84.9059C0 117.632 18.5147 146.033 45.6408 160.207L84.6977 200L123.328 160.641C150.913 146.619 169.812 117.97 169.812 84.9059C169.812 38.0137 131.798 0 84.9059 0Z'
        case svgShapes.chatBubble4Left:
            return 'M200 25L0 0L19 166L108 161L162 192L164 157.5L193 155Z'
        case svgShapes.chatBubble4Right:
            return 'M0 25L200 0L181 166L92 161L38 192L36 157.5L7 155Z'
    }
}

const getViewBoxByType = (type = svgShapes.star, padding = 0) => {

    const resultPadding = padding * 1;

    switch (type) {
        case svgShapes.star8:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${196 + resultPadding} ${200 + resultPadding}`
        case svgShapes.star:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${201 + resultPadding} ${191 + resultPadding}`
        case svgShapes.polygon6:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${174 + resultPadding} ${200 + resultPadding}`
        case svgShapes.polygon5:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${201 + resultPadding} ${191 + resultPadding}`
        case svgShapes.polygon6turned:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${124 + resultPadding}`
        case svgShapes.star4:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.star6:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.star4slim:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.diamond:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${145 + resultPadding}`
        case svgShapes.starTurned:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.heart:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${170 + resultPadding}`
        case svgShapes.flag:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${129 + resultPadding} ${200 + resultPadding}`
        case svgShapes.flagTriBottom:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${134 + resultPadding} ${200 + resultPadding}`
        case svgShapes.labelRight:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${108 + resultPadding}`
        case svgShapes.labelLeft:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${108 + resultPadding}`
        case svgShapes.lightning:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${137 + resultPadding} ${200 + resultPadding}`
        case svgShapes.trianglePlay:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${174 + resultPadding} ${200 + resultPadding}`
        case svgShapes.triangle:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${174 + resultPadding}`
        case svgShapes.cross:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.rhombus:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${200 + resultPadding}`
        case svgShapes.ribbon:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${124 + resultPadding}`
        case svgShapes.chatBubble1Left:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${154 + resultPadding}`
        case svgShapes.chatBubble1Right:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${154 + resultPadding}`
        case svgShapes.chatBubble2:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${164 + resultPadding} ${200 + resultPadding}`
        case svgShapes.chatBubble3:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${170 + resultPadding} ${200 + resultPadding}`
        case svgShapes.chatBubble4Left:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${192 + resultPadding}`
        case svgShapes.chatBubble4Right:
            return `${-resultPadding / 2} ${-resultPadding / 2} ${200 + resultPadding} ${192 + resultPadding}`
    }
}

const Path = (props = {
    type: svgShapes.star,
    borderRadius: 0,
    stroke: 0,
    strokeColor: 'rgba(255, 255, 255, 1)',
    strokeType: 'solid',
    uid: '12512626'
}) => {

    const path = getPathByType(props.type)
    const coords = pathToCoord(path)
    const roundedPath = createRoundedPathString(coords, props.borderRadius)
    const borderRadiusProhibited = svgShapesBoxList.find((el) => el.value == props.type && el.borderRadiusProhibit) != null || svgShapesShapeList.find((el) => el.value == props.type && el.borderRadiusProhibit) != null
    // console.log('borderRadius', props.borderRadius)

    let strokeDash = props.strokeType == 'solid' ? '' : props.strokeType == 'dotted' ? `1,${props.stroke * 2}` : `${props.stroke},${props.stroke * 2}`
    return (
        <path stroke={props.strokeColor} strokeWidth={props.stroke} strokeLinecap={props.strokeType == 'dotted' ? 'round' : 'square'} strokeDasharray={strokeDash} d={!props.borderRadius || borderRadiusProhibited ? path : roundedPath} />
    )
}

export const RenderSvgShape = (props =
    {
        type: svgShapes.star,
        dimensions: { width: 100, height: 100 },
        style: {},
        backgroundColorType: 'color',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        uid: '125125',
        borderRadius: 0,
        stroke: 0,
        strokeColor: 'rgba(255, 255, 255, 1)',
        strokeType: 'solid',
        glassBlur: false
    }) => {

    const fill = props.backgroundColorType == 'color' ? props.backgroundColor.colorValue : ''

    return (

        <svg id={`svg-shape-${props.uid}`} className={`svg-shape-${props.uid}`} style={{ fill: fill, ...props.style }} width={props.dimensions.width} height={props.dimensions.height} preserveAspectRatio="none" viewBox={getViewBoxByType(props.type, props.stroke)} xmlns="http://www.w3.org/2000/svg">
            {
                props.backgroundColorType == 'gradient' &&
                <SvgStyle
                    uid={props.uid}
                    layers={props.backgroundColor.gradientLayers}
                />
            }
            {
                props.backgroundColor.gradientLayers && props.backgroundColor.gradientLayers.map((value, index) => {
                    if (index > 0) {
                        return null
                    }

                    return (
                        <GradientDef
                            gradientLayer={value}
                            uid={props.uid}
                            index={index}
                            key={`gradient-def-${index}-${props.uid}`}
                        />
                    )
                })
            }

            <Path
                type={props.type}
                borderRadius={props.borderRadius}
                stroke={props.stroke}
                strokeColor={props.strokeColor}
                strokeType={props.strokeType}
                uid={props.uid}
            />
        </svg>
    )
}